import Icon from '../components/Icon.vue'

Icon.register({
  newspaper: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M552 64H88C74.7 64 64 74.7 64 88V96H24C10.7 96 0 106.7 0 120V392C0 422.9 25.1 448 56 448H528C554.5 448 576 426.5 576 400V88C576 74.7 565.3 64 552 64zM56 400A8-8 0 0 0 48 392V144H64V392A8-8 0 0 0 56 400zM292 384H140C133.4 384 128 378.6 128 372V364C128 357.4 133.4 352 140 352H292C298.6 352 304 357.4 304 364V372C304 378.6 298.6 384 292 384zM500 384H348C341.4 384 336 378.6 336 372V364C336 357.4 341.4 352 348 352H500C506.6 352 512 357.4 512 364V372C512 378.6 506.6 384 500 384zM292 288H140C133.4 288 128 282.6 128 276V268C128 261.4 133.4 256 140 256H292C298.6 256 304 261.4 304 268V276C304 282.6 298.6 288 292 288zM500 288H348C341.4 288 336 282.6 336 276V268C336 261.4 341.4 256 348 256H500C506.6 256 512 261.4 512 268V276C512 282.6 506.6 288 500 288zM500 192H140C133.4 192 128 186.6 128 180V140C128 133.4 133.4 128 140 128H500C506.6 128 512 133.4 512 140V180C512 186.6 506.6 192 500 192z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/newspaper.js
// module id = fG/T
// module chunks = 144